import axios, { AxiosInstance, AxiosResponse } from 'axios';
import axiosRetry from 'axios-retry';
import { errorInterceptor } from './ErrorInterceptor';
import { CustomerId, SiteId } from '../types';
import withJWTRefreshment from './TokenService/withJWTRefreshment';

import { injectTokenToConfig } from './TokenService/injectTokenToConfig';
import { GcpRequest } from '../types/gcpRequet.types';
import { retryCondition } from './retryCondition';

class BapiService {
  bapiService: AxiosInstance;

  constructor(bapiServiceBaseUrl: string) {
    this.bapiService = axios.create({
      baseURL: bapiServiceBaseUrl,
    });
    this.bapiService = withJWTRefreshment(this.bapiService);

    axiosRetry(this.bapiService, {
      retries: Infinity,
      retryDelay: () => 1000,
      retryCondition,
    });

    this.bapiService.interceptors.response.use(
      (res) => res,
      (err) => errorInterceptor(err),
    );
  }

  async getCurrentGcpRequest(customerId: CustomerId, siteId: SiteId) {
    const config = await injectTokenToConfig(
      {},
      {
        customer: customerId,
        site: siteId,
      },
    );

    return this.bapiService
      .get(`/api/v1/${customerId}/${siteId}/gcp-requests?limit=1`, {
        ...config,
      })
      .then((response: AxiosResponse<GcpRequest[]>) => {
        return response.data;
      });
  }

  async getFlightMarkersLastModified(customerId: CustomerId, siteId: SiteId) {
    const config = await injectTokenToConfig(
      {},
      {
        customer: customerId,
        site: siteId,
      },
    );

    return this.bapiService
      .get(`/api/v1/${customerId}/${siteId}/flight-markers/last-modified`, {
        ...config,
      })
      .then((response: AxiosResponse<{ lastModified: string | null }>) => {
        return response.data;
      });
  }
}

const bapiClient = new BapiService(BackofficeApiUrl);

export const getBapiService = () => {
  return bapiClient;
};
